export enum UserRole {
  user = 'app-user',
  instructor = 'instructor',
}
